/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveExtraSimulationRecapCustomerAgreementMutation from '../graphql/mutations/SaveExtraSimulationRecapCustomerAgreementMutation.js';

export const useSaveExtraSimulationRecapCustomerAgreementMutation = () => {
  return useCommitMutation(SaveExtraSimulationRecapCustomerAgreementMutation, {
    dataProp: 'saveExtraSimulationRecapCustomerAgreement_M_simulation_recap'
  });
};

export default useSaveExtraSimulationRecapCustomerAgreementMutation;
